import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';
import './threescene.css';

function ThreeScene() {
  const mountRef = useRef(null);

  useEffect(() => {
    // Create a scene
    const scene = new THREE.Scene();

    // Add fog to the scene for a nebula effect
    scene.fog = new THREE.FogExp2(0x000000, 0.0015);

    // Set up camera
    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    camera.position.z = 800; // Move the camera far to give depth to the galaxy

    // Renderer
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(window.innerWidth, window.innerHeight);

    // Append the renderer's DOM element only if mountRef.current exists
    if (mountRef.current) {
      mountRef.current.appendChild(renderer.domElement);
    }

    // Create a star particle system
    const starGeometry = new THREE.BufferGeometry();
    const starMaterial = new THREE.PointsMaterial({
      color: 0xffffff,
      size: 0.5,  // Adjusted size for more realistic star appearance
    });

    const starVertices = [];
    for (let i = 0; i < 20000; i++) {  // Increased star count for a dense galaxy
      const x = (Math.random() - 0.5) * 2000;
      const y = (Math.random() - 0.5) * 2000;
      const z = (Math.random() - 0.5) * 2000;  // More randomness in all directions
      starVertices.push(x, y, z);
    }

    starGeometry.setAttribute(
      'position',
      new THREE.Float32BufferAttribute(starVertices, 3)
    );
    const stars = new THREE.Points(starGeometry, starMaterial);
    scene.add(stars);

    // Add ambient light to give a softer glow to the stars
    const ambientLight = new THREE.AmbientLight(0xaaaaaa, 0.5);
    scene.add(ambientLight);

    // Optionally add directional light to simulate a distant light source
    const directionalLight = new THREE.DirectionalLight(0x4444ff, 0.5);
    directionalLight.position.set(1, 1, 0).normalize();
    scene.add(directionalLight);

    // Animation loop
    const animate = () => {
      stars.rotation.x += 0.0005;
      stars.rotation.y += 0.0005;

      renderer.render(scene, camera);
      requestAnimationFrame(animate);
    };

    animate();

    // Handle window resize
    const handleResize = () => {
      renderer.setSize(window.innerWidth, window.innerHeight);
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
    };

    window.addEventListener('resize', handleResize);

    // Cleanup function
    return () => {
      window.removeEventListener('resize', handleResize);

      // Safely remove renderer DOM element only if it exists
      if (renderer && mountRef.current) {
        mountRef.current.removeChild(renderer.domElement);
      }

      // Properly dispose of Three.js objects to prevent memory leaks
      renderer.dispose();
      starGeometry.dispose();
      starMaterial.dispose();
    };
  }, []);

  return <div ref={mountRef} className="three-background" />;
}

export default ThreeScene;
